var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 15.6667H19.1668V17.3333H0.833496V15.6667H2.50016V1.49999C2.50016 1.27898 2.58796 1.06701 2.74424 0.910734C2.90052 0.754454 3.11248 0.666656 3.3335 0.666656H16.6668C16.8878 0.666656 17.0998 0.754454 17.2561 0.910734C17.4124 1.06701 17.5002 1.27898 17.5002 1.49999V15.6667ZM15.8335 15.6667V2.33332H4.16683V15.6667H15.8335ZM6.66683 8.16666H9.16683V9.83332H6.66683V8.16666ZM6.66683 4.83332H9.16683V6.49999H6.66683V4.83332ZM6.66683 11.5H9.16683V13.1667H6.66683V11.5ZM10.8335 11.5H13.3335V13.1667H10.8335V11.5ZM10.8335 8.16666H13.3335V9.83332H10.8335V8.16666ZM10.8335 4.83332H13.3335V6.49999H10.8335V4.83332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.68db5b3de444a95a4da69716906f5296.svg";
export { ForwardRef as ReactComponent };